module.exports = __webpack_public_path__ + "media/images/pic/kitty-individual-8b0b5e70489bb2125c744aa758a683ad.png";